import React, { FC, PropsWithChildren, useEffect, useRef } from 'react'
import styles from './CustomAlert.module.scss'
import Portal from './Portal' // Portal is Simplified and allows Scrolling of Page
import ModalConnector, { ConnectorProps as ModalProps } from 'connectors/Modal'
import CloseIcon from 'svg/close-x.svg'
import classNames from 'classnames'

type ModalComponentProps = ModalProps & {
  layout?: string
  styleOverride?: string
  isCloseButtonVisible?: boolean
  closeButtonStyles?: string
  onCloseModal?: () => void
}
const ModalComponent: FC<PropsWithChildren<ModalComponentProps>> = (props) => {
  const {
    children,
    closeButtonStyles = '',
    closeModal,
    isCloseButtonVisible,
    isModalAvailable,
    onCloseModal,
    styleOverride,
  } = props
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleCloseModal = () => {
    onCloseModal?.()
    closeModal()
  }

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus()
    }
  }, [buttonRef.current])

  // We check Redux state to see if NAME matches currrent modal
  if (!isModalAvailable) {
    return null
  }

  return (
    <Portal>
      <div className={`${styles.customAlert} ${styleOverride}`}>
        <aside role='dialog' aria-modal='true' tabIndex={-1}>
          {isCloseButtonVisible && (
            <button
              ref={buttonRef}
              className={classNames('defaultSvgButton', styles.closeButton, {
                [closeButtonStyles]: closeButtonStyles !== '',
              })}
              onClick={handleCloseModal}
              tabIndex={0}
            >
              <CloseIcon />
            </button>
          )}
          {children}
        </aside>
      </div>
    </Portal>
  )
}
export default ModalConnector(ModalComponent)
